module.exports = __webpack_public_path__ + "img/clientes.465aabb7.png";